import { render, staticRenderFns } from "./AtenderTicket.vue?vue&type=template&id=6f01a50c&scoped=true&"
import script from "./AtenderTicket.vue?vue&type=script&lang=js&"
export * from "./AtenderTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f01a50c",
  null
  
)

export default component.exports